import { loggedIn } from '../../../routes/conditional';
import { searchMedicines as searchMedicinesAction } from '../../../redux/modules/addmedicine';
import { selectedMedicine as selectMedicine, clearAddItemError } from '../../../redux/modules/neworder';
import paths from '../../../routes/paths';
import makeSearchFilters from '../../../redux/modules/addmedicine/filters';

export const page = {
  path: paths.createOrder.addMedicine,
  isAllowed: [loggedIn],
  action: ({ query }) => (query.search ? searchMedicinesAction(query.search) : null),
};

export const searchMedicines = {
  actionPath: '/actions/search-medicine',
  inputName: 'searchText',
  pharmacyIdInput: 'pharmacyId',
  action: ({ body }) => searchMedicinesAction(body.searchText, makeSearchFilters(body.pharmacyId)),
};

export const selectedMedicine = {
  inputName: 'medicine',
  mapMedicineNameToInputValue: m => JSON.stringify(m),
  actionPath: '/actions/select-medicine-name',
  action: req => {
    let medicine = '';
    try {
      medicine = JSON.parse(req.body.medicine);
    } catch (e) {
      // none
    }
    return selectMedicine(medicine);
  },
};

export const clearSelectionError = {
  actionPath: '/actions/clear-selection-error',
  action: () => clearAddItemError(),
};
